export default __webpack_public_path__ + "ba9133379d46b33d6fab87e86a66136b.png";